import { get, deleteRequest, postForF, putForF } from './api'
import { getServerInfo } from '../utils/helpers/networkInfo.helper'

const serverUrl = getServerInfo('api')

export class LaboratoryService {
  static getAll(token, queryParams = {}) {
    return get(`${serverUrl}laboratories`, token, queryParams)
  }

  static getById(id, token) {
    return get(`${serverUrl}laboratories/${id}`, token)
  }

  static bulkDelete(ids, token) {
    return deleteRequest(`${serverUrl}laboratories`, { ids }, true, token)
  }

  static delete(id, token) {
    return deleteRequest(`${serverUrl}laboratories/${id}`, null, false, token)
  }

  static create(data, token) {
    return postForF(`${serverUrl}laboratories`, data, true, token)
  }

  static update(id, data, token) {
    return putForF(`${serverUrl}laboratories/${id}`, data, true, token)
  }

  //Obtener pods asociadas a un laboatorio por id (laboratory_id)
  static getpodxLaboratoryById(id, token) {
    return get(`${serverUrl}podxLaboratory/${id}`, token)
  }

  //Obtener laboratorios asociadas a un curso por id (pod_id)
  static getCoursesxLaboratoriesById(id, token) {
    return get(`${serverUrl}coursesxLab/${id}`, token)
  }

  //Obtener laboratorios asociadas a un curso por id y el schudle
  static getCoursesxLaboratoriesxSchedule(id, token) {
    return get(`${serverUrl}coursesxLabxScheduler/${id}`, token)
  }

  static getlaboratoriesxAllUser(id, token) {
    return get(`${serverUrl}laboratoriesxAllUser/${id}`, token)
  }

  static getLaboratoriesxcourse(token, queryParams = {}) {
    return get(`${serverUrl}laboratoriesxcourse`, token, queryParams)
  }
}
